import { React, useState, useEffect } from "react";
import {
  ADANI_COLOR_PALATE,
  ACC_COLOR_PALATE,
  AMBUJA_COLOR_PALATE,
  DARPAN_COLOR_PALATE,
} from "../constants/common";

const Box = ({ column = 3, children, bgColor = "" , className = ''}) => {
  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;

  const [palate, setPalate] = useState([]);

  async function getBrandThemePalate() {
    let palate = ADANI_COLOR_PALATE;
    const id = brandId;
    switch (id + "") {
      case "1":
        palate = ACC_COLOR_PALATE;
        break;
      case "2":
        palate = AMBUJA_COLOR_PALATE;
        break;
      case "Darpan":
        palate = DARPAN_COLOR_PALATE;
        break;
      default:
        palate = ADANI_COLOR_PALATE;
    }
    setPalate(palate);
  }

  useEffect(() => {
    getBrandThemePalate();
  }, [brandId]);

  return (
    <>
      <div
        className="dashboard-box" 
        // className={`box col-span-${column} ${className}`}
        // style={{
        //   backgroundColor: bgColor,
        //   borderRadius: "5px",
        //   padding: "16px",
        //   display: "flex",
        //   justifyContent: "space-evenly",
        //   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        //   margin: "8px",
        //   color: "#000",
        //   maxHeight: "112px",
        //   maxWidth: "202px",
        //   minWidth: "202px",
        //   minHeight: "112px",
        //   border: "1px solid rgba(0, 0, 0, 0.2)",
        // }}
        // ++++++++++++++++++++++++++++
        // style={{
        //   backgroundColor: bgColor,
        //   borderRadius: "8px",
        //   padding: "16px",
        //   display: "flex",
        //   flexDirection: "column",
        //   alignItems: "center",
        //   justifyContent: "center",
        //   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        //   margin: "8px",
        //   color: "#000",
        //   width: "100%",
        //   maxWidth: "220px",
        //   minWidth: "199px",
        //   minHeight: "112px",
        //   border: "1px solid rgba(0, 0, 0, 0.2)",
        //   flex: `1 1 calc(100% / ${column} - 16px)`,
        // }}
        // ++++++++++++++++++
        style={{
  backgroundColor: bgColor,
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  margin: "8px",
  color: "#000",
  width: "100%",
  flex: `1 1 calc(100% / ${column} - 16px)`,
  maxWidth: "100%", 
  minWidth: "0", 
  minHeight: "112px",
  border: "1px solid rgba(0, 0, 0, 0.2)",
}}

      >
        {children}
      </div>
    </>
  );
};

export default Box;
